import React from "react";
import "./Logo.css";

const Logo: React.FC<{}> = () => {
    return (
        <div className={"logoBackground"}><img src="/logo-b-black-256x256-t.png" alt="Logo" className={"logo"}/></div>
    );
};

export default Logo;